
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcIntegrationTabs as ObcIntegrationTabsElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-tabs/integration-tabs.js';
 
 
 

 
 export const ObcIntegrationTabs = createComponent({
   react: React,
   tagName: 'obc-integration-tabs',
   elementClass: ObcIntegrationTabsElement,
   events: {
     
   }
  });
 
 